import { Component } from '@angular/core';
import { SwUpdate, VersionReadyEvent } from '@angular/service-worker';
import { filter } from 'rxjs/operators';
import { AppStateService } from '@core/services/app-state.service';

@Component({
    selector: 'app-update',
    template: '',
    styleUrls: [],
    standalone: false
})
export class UpdateComponent {
  constructor(
    private updates:SwUpdate,
    appStateService:AppStateService) { 
      updates.versionUpdates
        .pipe(filter((event): event is VersionReadyEvent => event.type === 'VERSION_READY'))
        .subscribe(event => {  
          console.log('Update available - Version:', event.latestVersion);
          console.log('Current Version:', event.currentVersion);
          appStateService.updateAvailable = true;
          appStateService.updatePrompt = ()=> {
            this.updates.activateUpdate().then(() => document.location.reload());
          };
        });
    }     
    
} 